export default "__VITE_ASSET__BtmX4voW__"